import Resource from './common/resource';

class Teams extends Resource {
  path = 'teams';
}

export default Teams;
